import React from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import * as reportApi from "../../api/reportApi";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import ScrollToTopBtn from "../common/ScrollToTop";

class YFFEconomyContacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts: [],
      page: 0,
      rowsPerPage: 50,
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    try {
      this.getYffEconomyContacts();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getYffEconomyContacts = async () => {
    const contacts = await reportApi.getYffEconomyContacts();

    if (contacts) {
      this.setState({ contacts });
    } else {
      this.setState({ contacts: [] });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handledownload = async () => {
    const excelfile = await reportApi.getYffEconomyContactsExcel();
    if (excelfile === false) {
      toast.error("Noe gikk galt...");
    }
  };

  compareBy = (key, direction) => {
    return (a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  sortBy = (key) => {
    const { sortDirection, contacts } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";
    const sortedArray = [...contacts].sort(this.compareBy(key, newDirection));

    this.setState({
      contacts: sortedArray,
      sortDirection: newDirection,
    });
  };

  render() {
    const columns = [
      { id: "companyName", label: "BEDRIFTSNAVN", minWidth: 150 },
      { id: "yffStatus", label: "Status", minWidth: 150 },
      { id: "yffStatusName", label: "YFF", minWidth: 150 },
      { id: "emailEconomiYff", label: "E-POST", minWidth: 150 },
    ];

    return (
      <Container maxWidth="lg">
        <main style={{ width: "100%", paddingTop: 80 }}>
          <Paper style={{ width: "100%", paddingTop: 10 }}>
            <Paper style={{ marginLeft: 15, marginRight: 15 }}>
              <div style={{ marginTop: 10, overflow: "auto" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          style={{
                            backgroundColor: "#eeeeee",
                            fontWeight: "bold",
                            fontSize: 16,
                            minWidth: column.minWidth,
                            cursor: "pointer",
                          }}
                          onClick={() => this.sortBy(column.id)}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {this.state.contacts.length > 0 ? (
                      this.state.contacts
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage +
                          this.state.rowsPerPage
                        )
                        .map((contact, index) => (
                          <TableRow key={index} hover>
                            {columns.map((column) => (
                              <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
                                {contact[column.id]}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          Ingen treff
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[10, 50, 100]}
                  component="div"
                  count={this.state.contacts.length || 0}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </div>
            </Paper>
            <div style={{ paddingTop: 15, paddingBottom: 15, marginLeft: 10 }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<CloudDownloadIcon />}
                onClick={this.handledownload}
              >
                Vis i Excel
              </Button>
            </div>
          </Paper>
        </main>
        <ScrollToTopBtn />
      </Container>
    );
  }
}

export default YFFEconomyContacts;
